import { CMSResource } from "app/resources/cmsresource";

export class HeaderConfigurationResource extends CMSResource {

	rid: number;	
//	searchBarActive: boolean;	
	logoActive: boolean;		
	logoImage: string;	
	logoImageString: string;
	logoImageEn: string;	
	logoImageEnString: string;
	logoImageDe: string;	
	logoImageDeString: string;
	logoImageFr: string;	
	logoImageFrString: string;
	//backgroundColor: string;	
	//textColor: string;

}